<div
  class="bg-center bg-no-repeat bg-cover card-stay-tuned my-[10rem] bg-base-blue-light"
  style="background-image: url('assets/images/textura-ea.jpg')"
  *ngIf="posts$ | async as posts"
>
  <ng-container *ngIf="isShowNormalPosts$ | async; else carouselTemplate">
    <app-post-stay-stuned [data]="posts.post"></app-post-stay-stuned>
  </ng-container>
  <ng-template #carouselTemplate>
    <app-carousel-stay-stuned [data]="posts.post"></app-carousel-stay-stuned>
  </ng-template>
  <div *ngIf="!!posts.all.length" class="school-detail">
    <a routerLink="/post/all" class="school-detail__action" translate>global.see-more</a>
  </div>
</div>
